import actionTypes from "../../actionTypes";

export const triggerNotificationLoaderAction = (data) => ({
  type: actionTypes.adminTypes.engagementCenter.TRIGGER_NOTIFICATION_LOADER,
  payload: data,
});
export const deleteNotificationLoaderAction = (data) => ({
  type: actionTypes.adminTypes.engagementCenter.DELETE_NOTIFICATION_LOADER,
  payload: data,
});
